export default __webpack_public_path__ + "static/media/insta.02e567fc.svg";